<template>
  <label
    class="checkbox-input"
    :class="{ 'disabled': disabled }"
    data-pendo-gc="checkbox_input"
    :style="{ gap, alignItems: alignment }"
  >
    <input
      ref="checkboxInput"
      :checked="checked"
      :data-testid="dataTestid"
      :disabled="disabled"
      :indeterminate="indeterminate"
      type="checkbox"
      @change="$emit('update:checked', $event.target.checked)"
    >
    <CheckboxDecoration
      :checked="checked"
      :disabled="disabled"
      :focusable="focusable"
      :indeterminate="indeterminate"
      @focus-update="toggleChecked()"
    />
    <slot name="label">
      {{ label }}
    </slot>
  </label>
</template>

<script>
import CheckboxDecoration from './CheckboxDecoration.vue'

export default {
  name: 'CheckboxInput',
  components: {
    CheckboxDecoration,
  },
  props: {
    checked: {
      type: Boolean,
      default: false,
    },
    indeterminate: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    gap: {
      type: String,
      default: 'var(--space-1)',
    },
    alignment: {
      type: String,
      default: 'center',
    },
    label: {
      type: String,
      default: '',
    },
    dataTestid: {
      type: String,
      default: 'checkbox-input',
    },
    focusable: {
      type: Boolean,
      default: true,
    },
  },
  emits: ['update:checked'],
  methods: {
    toggleChecked() {
      this.$emit('update:checked', !this.checked)
    },
  },
}
</script>

<style scoped lang="scss">
.checkbox-input {
  cursor: pointer;
  display: flex;
  align-items: center;
  width: fit-content;
  margin: 0;
  padding: 0;
  font-weight: inherit;

  &.disabled {
    cursor: auto;
    color: var(--pepper-600);
  }

  input {
    display: none;
  }
}
</style>
